export interface BoonStyle {
    height?: string;
    width?: string;

    fontColor?: string;
    backgroundColor?: string;

    hoverFontColor?: string;
    hoverBackgroundColor?: string;

    contentClasses?: string;

    fontFamily?: string;
    fontSize?: string;
}

export const resolveProperty = (
    propertyName: string,
    overrideSheet: BoonStyle,
    templateSheet: BoonStyle = null,
    defaultSheet: BoonStyle = null
) => {
    if (!propertyName) {
        return '';
    }

    const propertyValue =
        (overrideSheet && overrideSheet[propertyName] ? overrideSheet[propertyName] : null) ||
        (templateSheet && templateSheet[propertyName] ? templateSheet[propertyName] : null) ||
        (defaultSheet && defaultSheet[propertyName] ? defaultSheet[propertyName] : null);

    return propertyValue ? propertyValue : '';
};

export const prefixIfNonEmpty = (prefix: string, value: string, delimiter = '-') => {
    return value ? `${prefix}${delimiter}${value}` : '';
};

export const toTextClass = (value: string) => {
    return prefixIfNonEmpty('text', value);
};

export const toBackgroundClass = (value: string) => {
    return prefixIfNonEmpty('bg', value);
};

export const toBorderClass = (color: string) => {
    return prefixIfNonEmpty('border', color);
};

export const toGroupHoverClass = (value: string) => {
    return prefixIfNonEmpty('group-hover', value, ':');
};

export const toGroupHoverTextClass = (value: string) => {
    return toGroupHoverClass(toTextClass(value));
};

export const toGroupHoverBackgroundClass = (value: string) => {
    return toGroupHoverClass(toBackgroundClass(value));
};

export const flattenClassesToString = (...classes: string[]) => {
    if (!classes) {
        return '';
    } else {
        const classList = [];
        classes.forEach(entry => {
            const trimmedEntry = !entry ? '' : entry.trim();
            if (trimmedEntry) {
                classList.push(trimmedEntry);
            }
        });
        return classList.join(' ');
    }
};
